<form (ngSubmit)="submitForm()" [formGroup]="checkoutSubmitForm">
  <div class="mb-6" *ngIf="showTermsAndConditions">
    <!--  This is just a quick solution, so the testers can acces the checkoutoderconfirmation page. An extra Ticket will be created for the final version of the TermsAndConditions-->
    <app-form-checkbox>
      <app-form-label>
        <small>
          {{ 'habaPlaceOrder.agb' | cxTranslate }}
          {{ 'habaPlaceOrder.dataProtection' | cxTranslate }}
        </small>
      </app-form-label>
      <input appFormCheckbox type="checkbox" formControlName="termsAndConditions" />
    </app-form-checkbox>
  </div>
  <div>
    <button
      class="btn btn-add-to-cart btn-full"
      type="submit"
      [disabled]="
        preventSubmit ||
        (emporixStockService.requestPending | async) ||
        (hasOnlyOutOfStockProducts$ | async)
      "
      [attr.data-qa]="submitButtonId?.getButtonId()"
    >
      <span appButtonText>{{ 'habaPlaceOrder.placeOrder' | cxTranslate }}</span>
    </button>
  </div>
</form>
